/**
 * useCallbackRef
 *
 * Created by Samuel on 2022/5/17
 */
import { useEffect, useMemo, useRef } from 'react';

export function useCallbackRef(callback) {
	const callbackRef = useRef(callback);

	useEffect(() => {
		callbackRef.current = callback;
	});

	// https://github.com/facebook/react/issues/19240
	return useMemo(
		() =>
			(...args) =>
				callbackRef.current?.(...args),
		[],
	);
}
